module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "nav-icon",
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon-round"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "expand-screen",
    on: {
      "click": _vm.toggleScreen
    }
  }, [_c('Tooltip', {
    attrs: {
      "placement": "bottom",
      "content": "full screen"
    }
  }, [(!_vm.screen) ? _c('Icon', {
    attrs: {
      "type": "android-expand"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.screen) ? _c('Icon', {
    attrs: {
      "type": "android-contract"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "msg-group-box"
  }, [_vm._t("msg-icon"), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fced4ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header/THeader.vue
// module id = 788
// module chunks = 10